// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__gjUWH","title":"styles_title__xfhXl","buttonsContainer":"styles_buttonsContainer__fjcj8"};